import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reader", "loading", "result"]
  static values = {
    domain: { type: String, default: "logcard.com.br" }
  }

  connect() {
    this._scanner = null
    this._isInitializing = false
    this._startScanner()

    this._visibilityHandler = () => {
      if (document.visibilityState === "hidden") this._stopScanner()
    }
    document.addEventListener("visibilitychange", this._visibilityHandler)
  }

  disconnect() {
    this._stopScanner()
    document.removeEventListener("visibilitychange", this._visibilityHandler)
  }

  async _startScanner() {
    if (this._isInitializing) return
    this._isInitializing = true

    if (this.hasLoadingTarget) this.loadingTarget.style.display = "block"

    try {
      if (typeof Html5Qrcode === "undefined") {
        await this._loadScript("https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js")
      }

      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
      stream.getTracks().forEach(track => track.stop())

      const devices = await Html5Qrcode.getCameras()
      if (!devices?.length) throw new Error("Nenhuma câmera encontrada")

      const rearCamera = devices.find(d => /back|traseira|rear/i.test(d.label))

      this._scanner = new Html5Qrcode(this.readerTarget.id)
      await this._scanner.start(
        rearCamera?.id || devices[0].id,
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => this._onScanSuccess(decodedText)
      )

      if (this.hasLoadingTarget) this.loadingTarget.style.display = "none"
    } catch (err) {
      this._showMessage(`Erro: ${err.message}`)
    } finally {
      this._isInitializing = false
    }
  }

  async _stopScanner() {
    if (this._scanner?.isScanning) {
      try { await this._scanner.stop(); this._scanner = null } catch (_e) { /* cleanup */ }
    }
  }

  _onScanSuccess(decodedText) {
    try {
      const url = new URL(decodedText)
      if (!url.hostname.includes(this.domainValue)) {
        this._showMessage("QR Code inválido")
        this._stopScanner()
        return
      }

      // Preservar query params da URL atual
      const currentParams = new URLSearchParams(window.location.search)
      currentParams.forEach((value, key) => {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value)
      })

      this._stopScanner()
      window.location.href = url.href
    } catch (_e) {
      this._showMessage("Texto lido não é uma URL válida")
      this._stopScanner()
    }
  }

  _showMessage(msg) {
    if (this.hasLoadingTarget) this.loadingTarget.style.display = "none"
    if (this.hasResultTarget) {
      this.resultTarget.style.display = "block"
      this.resultTarget.innerHTML = msg
    }
  }

  _loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = src
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}
